import axios from 'axios';
import { triggerSessionExpired } from './sessionExpiredHandler';
import { getLang } from '../../strings';
import { sessionService } from 'redux-react-session';

const backendRequest = (method = "GET", path, body = null, content_type = null) =>
    new Promise((resolve, reject) =>
        axios({
            method,
            url: path,
            data: body,
            headers: {
                "Accept-Language": getLang(),
                ...(content_type ? { "Content-Type": content_type } : {}),
            },
        })
            .then((res) => resolve(res.data))
            .catch(async (err) => {
                if (err?.response?.status === 401 && path !== "/users/am-i-logged-in") {
                    const storedUser = await sessionService.loadUser().catch(() => null);
                    const hadSession = !!storedUser && Object.keys(storedUser).length > 0;

                    if (hadSession) {
                        triggerSessionExpired();
                    }
                }

                reject(err.response);
            })
    );
export default backendRequest;
